export default "__VITE_ASSET__$wYVkYx7__"